module.exports = __webpack_public_path__ + "img/feature_buy_cn.f76e4830.png";